import Axios from '../../../../common/util/Axios';

const parseCompanyFromResponse = (data) => {
  if (!data) return null;
  if (Array.isArray(data)) return data[0] || null;
  return data;
};

const isRestaurantCompanyType = (type) =>
  String(type ?? '')
    .trim()
    .toUpperCase() === 'RESTAURANT';

const MODIFIER_COMPANY_TYPES = new Set(['RESTAURANT', 'RETAIL']);

const isModifierCompanyType = (type) =>
  MODIFIER_COMPANY_TYPES.has(String(type ?? '').trim());

const isRestaurantReceiptTemplate = (templateValue) =>
  String(templateValue ?? '')
    .toUpperCase()
    .includes('RESTAURANT');

const getBillReceiptTemplateFromSettings = (settingsRows) => {
  if (!Array.isArray(settingsRows)) return '';
  const row = settingsRows.find((item) => item?.param === 'bill-receipt-template');
  return row?.value ?? '';
};

/**
 * Restaurant and retail companies can author product modifiers.
 * Company type only. Receipt-template fallback stays on fetchIsRestaurantCompany.
 */
export const fetchIsModifierCompany = async (companyId) => {
  if (companyId == null || companyId === '') return false;

  try {
    const res = await Axios.get('/api/dashboard/companies/find-by', {
      params: { id: companyId },
    });
    const company = parseCompanyFromResponse(res.data?.data);
    return Boolean(company && isModifierCompanyType(company.type));
  } catch {
    return false;
  }
};

/**
 * Detect restaurant company for Bill History filters.
 * 1) company.type from companies/find-by
 * 2) bill-receipt-template from receipt settings (same source as Settings → Receipt page)
 */
export const fetchIsRestaurantCompany = async (companyId, branchId) => {
  if (companyId == null || companyId === '') return false;

  try {
    const res = await Axios.get('/api/dashboard/companies/find-by', {
      params: { id: companyId },
    });
    const company = parseCompanyFromResponse(res.data?.data);
    if (company && isRestaurantCompanyType(company.type)) {
      return true;
    }
  } catch {
    // fall through to receipt settings
  }

  if (branchId == null || branchId === '') return false;

  try {
    const res = await Axios.get('/api/dashboard/settings/find-receipt-settings-for-branch', {
      params: { companyId, branchId },
    });
    const template = getBillReceiptTemplateFromSettings(res.data?.data);
    return isRestaurantReceiptTemplate(template);
  } catch {
    return false;
  }
};
